import { render, staticRenderFns } from "./TestimonySlider.vue?vue&type=template&id=46c81606&scoped=true"
import script from "./TestimonySlider.vue?vue&type=script&lang=js"
export * from "./TestimonySlider.vue?vue&type=script&lang=js"
import style0 from "./TestimonySlider.vue?vue&type=style&index=0&id=46c81606&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c81606",
  null
  
)

export default component.exports